import * as React from 'react';
import * as UI from 'core/ui';
import { ActionButtonDefinition, PosScreenClassComponent } from 'pos/ui';
import { Res } from 'core/api';
import * as Images from 'pos/Images';
import { Flex } from 'core/ui';
import { Modal } from 'core/ui-next/modal';

type Props = Modal.Actions<RefundPaymentsMode>;

const Option = (props: { text: string, onClick: () => void, icon: SvgIcon }) => {
	const Image = props.icon;
	return <div style={{ display: 'flex', alignItems: 'center' }} >
		<div style={{ minWidth: 32 }}><Image /></div>
		<div className='m-l m-r-sm'>{props.text}</div>
		<div className='btn btn-default' onClick={props.onClick} style={{ minWidth: 64 }}><Images.Next /></div>
	</div>;
};

class GetPaymentsModeScreen extends PosScreenClassComponent<Props, EmptyState> {


	createInitialState(_props: Props): Nullable<EmptyState> {
		return null;
	}

	onComponentDidMount(): void { }

	onComponentWillUnmount(): void { }

	protected getScreenId(): string {
		return 'GET_PAYMENT_SCREEN_MODE';
	}


	protected getTitle(): string {
		return Res.Web.GET_REFUND_PAYMENTS_MODE();
	}

	protected getImage(): string | SvgIcon {
		return Images.RefundTicket;
	}

	protected useKeypad() {
		return false;
	}

	protected getScreenSize(): UI.ScreenSize {
		return 'small';
	}


	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			null
		];
	}

	protected getContent(): React.ReactNode {

		const onUsePreviousPayments = async () => this.close('OriginalPayments');
		const onUseNewPayments = async () => this.close('NewPayments');

		return <Flex.Vertical className='p-sm'>
			<Flex.Item className='text-18'>
				{Res.Web.GET_REFUND_PAYMENTS_MODE_QUESTION()}
			</Flex.Item>
			<Flex.Item className='m-t-xl'>
				<Option text={Res.Web.GET_REFUND_PAYMENTS_MODE_OLD_PAYMENTS()} icon={Images.RefundPayment} onClick={onUsePreviousPayments} />
			</Flex.Item>

			<Flex.Item style={{ marginTop: '80px' }}>
				<Option text={Res.Web.GET_REFUND_PAYMENTS_MODE_NEW_PAYMENTS()} icon={Images.ChangeInvoicePayment} onClick={onUseNewPayments} />
			</Flex.Item>

		</Flex.Vertical>;
	}
}

type RefundPaymentsMode = 'NewPayments' | 'OriginalPayments'

export async function getRefundPaymentsMode(): Promise<Result<RefundPaymentsMode>> {
	return await Modal.show(GetPaymentsModeScreen);
}
